import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import PredictionMarkets from "@/pages/PredictionMarkets";

export const Route = createFileRoute("/_app/prediction-markets/")({
  component: () => (
    <PageGate pageKey="prediction-markets"><PredictionMarkets /></PageGate>
  ),
});
